import { render, staticRenderFns } from "./mDataCenter.vue?vue&type=template&id=0e8d9505&scoped=true&"
import script from "./mDataCenter.vue?vue&type=script&lang=js&"
export * from "./mDataCenter.vue?vue&type=script&lang=js&"
import style0 from "./mDataCenter.vue?vue&type=style&index=0&id=0e8d9505&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8d9505",
  null
  
)

export default component.exports